import { createPositionResolver } from './resolver'
import type { PositionDef } from './types'

export const SoccerPosition = {
  Goalkeeper: 'Goalkeeper',
  Defender: 'Defender',
  Midfielder: 'Midfielder',
  Forward: 'Forward'
} as const

export type SoccerPosition =
  (typeof SoccerPosition)[keyof typeof SoccerPosition]

export const soccerPositions: ReadonlyArray<PositionDef<SoccerPosition>> = [
  {
    canonical: SoccerPosition.Goalkeeper,
    abbreviation: 'GKP',
    label: 'Goalkeeper',
    aliases: ['gk', 'goalie', 'keeper', 'goalkeepers']
  },
  {
    canonical: SoccerPosition.Defender,
    abbreviation: 'DEF',
    label: 'Defender',
    aliases: ['defenders', 'def', 'defence', 'defense', 'back']
  },
  {
    canonical: SoccerPosition.Midfielder,
    abbreviation: 'MID',
    label: 'Midfielder',
    aliases: ['midfielders', 'mid', 'midfield']
  },
  {
    canonical: SoccerPosition.Forward,
    abbreviation: 'FWD',
    label: 'Forward',
    aliases: ['forwards', 'fwd', 'attacker', 'attackers', 'striker', 'strikers']
  }
]

export const soccerPositionResolver = createPositionResolver(soccerPositions)
